import { index, integer, pgTable, text, timestamp, uniqueIndex, uuid } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { users } from "./users";
import { sql } from "drizzle-orm";
export const membershipInvites = pgTable("membership_invites", {
    id: uuid("id").primaryKey().defaultRandom(),
    email: text("email").notNull(),
    organisationId: uuid("organisation_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    invitedByUserId: uuid("invited_by_user_id").references(() => users.id, {
        onDelete: "set null",
    }),
    role: text("role").notNull().$type().default("member"),
    status: text("status").notNull().$type().default("pending"),
    token: text("token").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    expiresAt: timestamp("expires_at", { withTimezone: true }).notNull(),
    acceptedAt: timestamp("accepted_at", { withTimezone: true }),
    acceptedByUserId: uuid("accepted_by_user_id").references(() => users.id, {
        onDelete: "set null",
    }),
    revokedAt: timestamp("revoked_at", { withTimezone: true }),
    remindersSent: integer("reminders_sent").notNull().default(0),
}, table => ({
    tokenUnique: uniqueIndex("membership_invites_token_unique").on(table.token),
    pendingEmailUnique: uniqueIndex("membership_invites_pending_email_unique")
        .on(table.email)
        .where(sql `${table.status} = 'pending'`),
    statusIdx: index("membership_invites_status_idx").on(table.status),
    emailOrgStatusIdx: index("membership_invites_email_org_status_idx").on(table.email, table.organisationId, table.status),
}));
